import { compose, concat, propOr, propEq, find } from 'ramda';

export const formatPhone = (phones, mobile = true) =>
  compose(
    (phone) => concat(propOr('', 'internationalCode', phone), propOr('', 'number', phone)),
    find(propEq('isMobile', mobile))
  )(phones);
